import { node, number } from "prop-types";
import { forwardRef, useCallback, useRef } from "react";

import styled from "styled-components";

import dynGap from "Utilities/interpolations/dynGap";

import useClampedBottom from "./useClampedBottom";

const ButtonGroupContainer = forwardRef(({ gap = 8, children }, ref) => {
  const containerRef = useRef(null);
  const mergedRef = useCallback(
    (el) => {
      containerRef.current = el;
      if (typeof ref === "function") ref(el);
      else if (ref) ref.current = el;
    },
    [ref]
  );
  useClampedBottom(containerRef);

  return (
    <Container ref={mergedRef}>
      <ButtonGroup $gap={gap}>{children}</ButtonGroup>
    </Container>
  );
});

ButtonGroupContainer.propTypes = {
  gap: number,
  children: node,
};

const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 12px 14px 16px 14px;
`;

const ButtonGroup = styled.div`
  display: flex;
  ${dynGap}
  width: fit-content;
  transition: gap 300ms;
`;

export default ButtonGroupContainer;
